const isPdf = (file?: IFile) => !!file?.absolutePath?.endsWith("pdf");

/**
 * The document body of the agreement dialog.
 *
 * A PDF handed to the browser is the slow path: the built-in viewer takes
 * seconds to start on kiosk hardware, and inside a WebView there is no viewer at
 * all. So the server renders each page to an image up front and those are drawn
 * here instead — plain <img>, cached by the service worker like any other asset.
 *
 * The PDF stays as the fallback for documents that have not been rendered yet
 * (the job runs after upload) or where rendering failed.
 */
const AgreementDocument = ({ file }: { file?: IFile }) => {
  if (!file?.absolutePath) {
    return null;
  }

  const pages = file.pages ?? [];

  if (pages.length > 0) {
    return (
      // No scroller of its own: the dialog content scrolls, see AggrementDialog.
      <div className="ea-pages">
        {pages.map((page, index) => (
          <img
            key={page.id}
            src={page.absolutePath}
            alt=""
            className="w-100 d-block"
            // A native image drag cancels the pointer and would stop the scroll.
            draggable={false}
            /**
             * The first page is what the visitor is waiting on; the rest can
             * arrive as they scroll.
             */
            loading={index === 0 ? "eager" : "lazy"}
          />
        ))}
      </div>
    );
  }

  if (isPdf(file)) {
    return (
      <iframe
        title="aggrement"
        src={`${file.absolutePath}#toolbar=0`}
        width="100%"
        height="98%"
      />
    );
  }

  return (
    <div
      className="ea-image h-100"
      style={{ backgroundImage: `url("${file.absolutePath}")` }}
    />
  );
};

export default AgreementDocument;
